var _path, _circle, _circle2, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProductSectionAccessRestrictedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80 8C59.5655 8 43 24.5655 43 45V108H56V45C56 31.7452 66.7452 21 80 21C93.2548 21 104 31.7452 104 45V108H117V45C117 24.5655 100.435 8 80 8Z",
    fill: "#E7E9EC"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 100,
    r: 50,
    fill: "#077DDF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 100,
    r: 37,
    fill: "#1E95F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.3528 85.3522C67.9752 84.7298 68.9844 84.7298 69.6067 85.3522L80.5006 96.2461L91.3945 85.3522C92.0169 84.7298 93.026 84.7298 93.6484 85.3522C94.2708 85.9746 94.2708 86.9837 93.6484 87.6061L82.7545 98.5L93.6484 109.394C94.2708 110.016 94.2708 111.025 93.6484 111.648C93.026 112.27 92.0169 112.27 91.3945 111.648L80.5006 100.754L69.6067 111.648C68.9844 112.27 67.9752 112.27 67.3528 111.648C66.7304 111.025 66.7304 110.016 67.3528 109.394L78.2467 98.5L67.3528 87.6061C66.7304 86.9837 66.7304 85.9746 67.3528 85.3522Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductSectionAccessRestrictedIcon);
export default __webpack_public_path__ + "static/media/ProductSectionAccessRestrictedIcon.6e461eb5.svg";
export { ForwardRef as ReactComponent };